<template>
  <div style="height: 320px">
    <SwapMenu2 :swapid="swapid" title="STATISTIC REPORT" margin="1">
      <template v-slot:menu>
      <li> <a class="dropdown-item" @click="refresh()">Refresh</a> </li>
      </template>
    </SwapMenu2>

    <div class="table-responsive divstyle">
       <br>
       <table>

       <tr>
       <td>REPORT</td><td>:</td>
       <td>
         <select v-model="selected.dir" @change="change_month()">
         <option v-for="k in statdirs" :value="k.dir" :key="k.dir">
              {{k.dir}} - {{k.name}}
            </option>
         </select>
       </td>
       </tr>

       <tr>
       <td>Period</td><td>:</td><td>
       <select v-model="selected.month">
           <option v-for="m in months" :value="m" :key="m">
               {{m}}
            </option>
       </select><br>
       </td></tr>

       <tr>
       <td>GraphPeriod</td><td>:</td><td>
         <select v-model="selected.md" @change=getstatsum()>
           <option value="monthly" >Monthly</option>
           <option value="daily">Daily</option>
         </select>
       </td></tr>

       <tr v-if="selected.md=='daily'">

       <td>Day</td><td>:</td><td>
         <select v-model="selected.day">
           <option v-for="d in statsum.daylist" :value="d" :key="d">
               {{d}}
            </option>
         </select>
       </td></tr>

       <tr>
       <td>Graph Base</td><td>:</td><td>
         <select v-model="selected.base">
           <option value="INCP">incoming Proc Code</option>
           <option value="OUTP">Outgoing Proc Code</option>
           <option value="INCR">Incoming Response</option>
           <option value="OUTR">Outgoing Response</option>
         </select>
       </td>
       </tr>

       <tr>
       <td>Graph type</td><td>:</td><td>
         <select v-model="selected.graph">
           <option value="PIE">PIE</option>
           <option value="BAR">BAR</option>
           <option value="LINE">LINE</option>
         </select>
       </td>
       </tr>

       <template v-if="selected.graph != 'LINE'">
         <tr v-if="selected.base =='INCR' || selected.base == 'OUTR'">
         <td>Filter Resp</td><td>:</td><td>
           <select v-model="selected.rfilter">
             <option value="INCL00" :key="p">INCLUDE 00</option>
             <option value="EXCL00" :key="p">EXCLUDE 00</option>
           </select>
         </td></tr>
       </template>
       <template v-if="selected.graph == 'LINE'">
         <tr v-if="selected.base=='INCP' || selected.base == 'OUTP'">
         <td>Proc Code</td><td>:</td><td>
           <select v-model="selected.proc">
             <option v-for="p in proccode" :value="p" :key="p">
               {{p}}
              </option>
           </select>
         </td></tr>

         <tr v-if="selected.base=='INCR' || selected.base == 'OUTR'">
         <td>Resp Code</td><td>:</td><td>
            <select v-model="selected.resp">
             <option v-for="r in resplist" :value="r" :key="r">
               {{r}}
              </option>
           </select>
         </td></tr>

         <tr>
         <td>Model</td><td>:</td><td>
           <select v-model="selected.model">
             <option value="APRRATE" :key="p">APPROVAL RATE</option>
             <option value="RESPTIME" :key="p">RESPONSE TIME</option>
             <option value="VOLUME" :key="p">VOLUME</option>
           </select>
         </td></tr>

       </template>

       </table>
       <div style='margin:auto;width:auto'>
          <div v-if="errormsg !=''" class="border mb-3" 
            style='color:red;background:yellow'>
            {{errormsg}}
          </div>

          <br v-if="errormsg == ''">
          <div style='margin:auto;width:3rem'>
            <button class="btn btn-primary btn-block mb-4" @click=drawgraph> 
            Draw</button>
          </div>
      </div>
    </div> 
  </div>
  <ErrorModal :swapid="swapid" modalid="ERRMODAL03"><p>{{errormsg}}</p></ErrorModal>
</template>

<style scoped>
.divstyle {
    font-size : 10pt ;
}
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.thx {
   height : 12px ;
   padding : 0 ;
}

.myheadline {
    height: 14pt ;
    background : #5090FF ;
    padding : 0px;
    margin : 0px;
}

.tralign {
  height: 12px ;
  text-algin: left ;
}


.rightalign {
    float: right ;
    width: 250px ;
}
.leftalign {
    float: left ;
}
tbody tr:hover {
  background-color: yellow;
  cursor: pointer ;
}

.colpad {
  padding: 2px !important ;
  font-size: 10pt ;
  text-align : left ;
  white-space: nowrap ;
  overflow : auto ;
}
.headline {
  background : #8080FF;
  color : white ;
}
</style>

<script>
import axios from 'axios'
import ErrorModal from './ErrorModal.vue'
import bootstrap from 'bootstrap/dist/js/bootstrap.js'
import SwapMenu2 from './SwapMenu2.vue' 

export default {
  name: 'ReportStat',
  components: {
     ErrorModal, SwapMenu2
  },
  props: {
    swapid : String
  },
  computed : {
    months() {
      if (this.selected.dir == "NONE")
          return [ "0000" ] ;
      for (let i = 0 ; i < this.statdirs.length ; i++) {
        if (this.selected.dir == this.statdirs[i].dir)
            return this.statdirs[i].months ;
      }
      return [ "0000" ] ;
    },
    resplist () {
      let resplst = [ ]
      let sumtab = this.statsum.sumtab ;
      for (let i = 0 ; i < sumtab.length ; i++) {
         let sum = sumtab[i] ;
         if (sum.key["3"] == "RESPONCODE") {
            if (this.selected.base.startsWith("INC")) {
                if (sum.key["2"] == "P-I")
                   resplst.push( sum.key["7"] ) ;
            }
            if (this.selected.base.startsWith("OUT")) {
                if (sum.key["2"] == "P-O")
                   resplst.push( sum.key["7"] ) ;
            }
         }
      }
      resplst.sort();
      return resplst ;
    },
    proccode () {
      let proclst = [ "000ALL" ]
      let sumtab = this.statsum.sumtab ;
      for (let i = 0 ; i < sumtab.length ; i++) {
         let sum = sumtab[i] ;
         if (sum.key["3"] == "PROCCODE") {
            if (this.selected.base.startsWith("INC")) {
                if (sum.key["2"] == "P-I")
                   proclst.push( sum.key["7"] ) ;
            }
            if (this.selected.base.startsWith("OUT")) {
                if (sum.key["2"] == "P-O")
                   proclst.push( sum.key["7"] ) ;
            }
         }
     }
     proclst.sort() ;
     return proclst ;
    }
  },
  data() {
    return {
        selected : {
            model : "",
            graph : "",
            proc : "",
            rfilter: "INCL00",
            resp : "",
            md  : "",      /* monthly or daily */
            dir : "NONE",
            month : [ "0000" ],
            day : "",      /* selected day */
            base : ""     /* 4 type */
        },
        statdirs : [ { dir : "NONE", name : "NODATA" } ],
        statsum : { "daylist" : [], "sumtab" : [] },
        lastsum : "",
        errormsg : "" 
    }
  },
  mounted() {
    this.getstatdir() ;
  },
  methods : {
    change_month() {
       this.selected.md = "" ;
    },
    refresh() {
        this.getstatdir();
    },
    getstatdir() {
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/stat/get" + "?swapid=" + this.swapid ;
        }
        catch(err) {
           console.log(err) ;
           return ;
        }
        axios.get (req, {
           timeout: 5000,
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
           if (typeof response.data != "object") { 
               this.statdirs = [ { dir : "ERROR", name : "NOT OBJECT" } ] ;
               return ;
           }

           if (response.data.RC != "00") {
               this.statdirs = [ { dir : "ERROR", name : "RC " + 
                    response.data.RC + " -- " + response.data.RDESC } ] ;
               return ;
           }
           this.statdirs = response.data.RESULT ;
           this.selected.dir = this.statdirs[0].dir ;
           this.selected.month = this.statdirs[0].months[0] ;

        }).catch ( (error) => { console.log(error) })
    },
    drawgraph() {
        let req = this.$store.getters.controller_url +
              "/prosw/stat/graph/" + this.selected.dir + "/" + 
              this.selected.month + "?swapid=" + this.swapid ;

        let selmd   = "&selmd=" + this.selected.md  ;
        let selday  = "&selday=" + this.selected.day ;

        let selbase = "&selbase=" + this.selected.base ;
        let selproc = "&selproc=" + this.selected.proc ;
        let selresp = "&selresp=" + this.selected.resp ;
        let selrfilter = "&selrfilter=" + this.selected.rfilter;
        let selmodel = "&selmodel=" + this.selected.model;
        let selgraph = "&selgraph=" + this.selected.graph ;


        
        let query = selmd ;
        if (this.selected.md == "daily") {
            if (this.selected.day == '')
                return alert ("selected day must be fill") ;
            query += selday ;
        }
        query += selbase + selgraph ;

        if (this.selected.graph != 'LINE')
            query += selrfilter ; 
        else {
            query += selresp ;
            query += selproc ;
            query += selmodel ;
        }

        req = req + query ;
        axios.get (req, {
           timeout: 5000,
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
           if (typeof response.data != "object") { 
               this.errormsg = "invalid response not object" ;
               return ;
           }

           if (response.data.RC != "00") {
               this.errormsg = "Resp RC " + response.data.RC + " -- " +
                            response.data.RDESC ;
               return ;
           }
           this.$parent.drawgraph(this.selected, response.data.RESULT) ;
        }).catch ( (error) => { console.log(error) })
    },
    getstatsum() {
        let lastsum = this.selected.dir + "/" + this.selected.month ;

        if (this.lastsum == lastsum) return ;

        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/stat/sum/" + this.selected.dir + "/" + 
                    this.selected.month + "?swapid=" + this.swapid ;
        }
        catch(err) {
           console.log(err) ;
           return ;
        }
        axios.get (req, {
           timeout: 5000,
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
           if (typeof response.data != "object") { 
               this.statsum = { daylist : [], "sumtab" : [] } ;
               return ;
           }

           if (response.data.RC != "00") {
               this.statsum = { daylist : [], "sumtab" : [] } ;
               return ;
           }
           this.statsum = response.data.RESULT ;
           this.statsum.daylist.sort();
           this.lastsum == lastsum ;
           

        }).catch ( (error) => { console.log(error) })
    },
    getAbsPosition(el) {
        let el2 = el;
        let curtop = 0;
        let curleft = 0;
        if (document.getElementById || document.all) {
            do  {
                curleft += el.offsetLeft-el.scrollLeft;
                curtop += el.offsetTop-el.scrollTop;
                el = el.offsetParent;
                el2 = el2.parentNode;
                while (el2 != el) {
                    curleft -= el2.scrollLeft;
                    curtop -= el2.scrollTop;
                    el2 = el2.parentNode;
                }
            } while (el.offsetParent);
        } else if (document.layers) {
            curtop += el.y;
            curleft += el.x;
        }
        return { 'top' : curtop, 'left' :  curleft } ;
    },
    showerror(error, modalX, modalY) {
        let modalid = "ERRMODAL03" ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal(
            document.getElementById(modalid), { backdrop : false }) ;
        this.errormsg = error;
        divmodal.style.top =  (modalY - 50) + 'px' ;
        divmodal.style.left = modalX + 20 + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    runload(filenm) {    
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/file/" + "load?swapid=" + this.swapid  + 
                "&filename=" + this.currentdir + "/" + filenm  ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        axios.get (req,  {
           timeout: 15000,
           responseType: 'blob', 
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (res) => {
            let FILE = window.URL.createObjectURL(new Blob([res.data]));
            var docUrl = document.createElement('a');
            docUrl.href = FILE;
            docUrl.setAttribute('download', filenm);
            document.body.appendChild(docUrl);
            docUrl.click();
       }).catch ( (error) => { 
            if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
            } else {
                console.log(error.message);
          }
       })
    },
    runfile(cmd) {    // toggle start or stop swap
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/file/" + cmd ; 
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        axios.get (req,  {
           timeout: 5000,
           responseType: 'text',
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
            let res = response.data ;
            let frame1 = document.getElementById("IFRAME01");
            let myframe = frame1.contentWindow.document;
            myframe.open() ;
            if (typeof res == "object") {
                let myarray = res.RESULT.split ("\n") ;
                myarray.forEach ( line => myframe.write(line + "<br>") )
            }
            else {
                myframe.write ("<pre>");
                myframe.write (response.data) ;
                myframe.write ("</pre>") ;
            }
            myframe.close();
       }).catch ( (error) => { 
            if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
            } else {
                console.log(error.message);
          }
       })
    },
  }
}
/*
    options    : list of pswline_logaddr keteranagan (dari fifo)
    monthly    : monthly/daily
    select     : month/day
    type       : RC / PROC
    subtype    : ALL / ALLINC / ALLOUT 
    graph      : bargraph / linegraph / RawData
*/
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>
